import { Controller } from "@hotwired/stimulus"

// Lovingly copy-pasta'd from:
// https://github.com/stimulus-components/stimulus-character-counter

// Connects to data-controller="character-counter"
export default class extends Controller {
  static targets = ["input", "counter"]

  initialize() {
    this.update = this.update.bind(this)
  }

  connect() {
    this.update()
    this.inputTarget.addEventListener("input", this.update)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.update)
  }

  update() {
    this.counterTarget.innerHTML = this.count.toString()
  }

  get count() {
    return this.inputTarget.value.length
  }
}
